export const companyInfo = {
  name: "두꺼비대출",
  bizName: "두꺼비대출",
  ceo: "임꺽정",
  phone: "0000-0000",
  address: "",
  bizNumber: "",
  loanRegNumber: "",
  regAgency: "",
  regAgencyPhone: "",
};

export const navLinks = [
  { label: "개인사업자", href: "/personal" },
  { label: "법인사업자", href: "/corporate" },
  { label: "자영업자대출", href: "/self-employed" },
  { label: "기업단기자금", href: "/enterprise" },
  { label: "일수대출", href: "/daily" },
];

export const loanProducts = [
  {
    id: 1,
    title: "기업단기자금",
    subtitle: "기업들의 자금 융통을 위한 간편 대출",
    maxAmount: "최대 10억원",
    tags: ["#자금융통", "#기업", "#간편대출"],
    slug: "enterprise",
    image: "https://readdy.ai/api/search-image?query=Modern%20corporate%20finance%20concept%2C%20business%20building%20with%20blue%20sky%2C%20professional%20office%20exterior%2C%20glass%20skyscraper%2C%20clean%20aesthetic%2C%20bright%20lighting%2C%20minimal%20background&width=600&height=400&seq=dukk-product-01&orientation=landscape",
  },
  {
    id: 2,
    title: "법인사업자대출",
    subtitle: "법인 대표님들을 위한 든든한 사업자대출",
    maxAmount: "최대 10억원",
    tags: ["#법인대표", "#사업자대출", "#든든한자금"],
    slug: "corporate",
    image: "https://readdy.ai/api/search-image?query=Professional%20business%20executive%20meeting%20room%2C%20corporate%20boardroom%2C%20modern%20conference%20table%2C%20blue%20tinted%20glass%20windows%2C%20bright%20professional%20atmosphere%2C%20clean%20minimal%20design&width=600&height=400&seq=dukk-product-02&orientation=landscape",
  },
  {
    id: 3,
    title: "개인사업자대출",
    subtitle: "개인사업자 사장님을 위한 넉넉한 맞춤대출",
    maxAmount: "최대 10억원",
    tags: ["#개인사업자", "#맞춤대출", "#당일승인"],
    slug: "personal",
    image: "https://readdy.ai/api/search-image?query=Small%20business%20owner%20working%20at%20clean%20modern%20desk%2C%20retail%20shop%20interior%2C%20professional%20entrepreneur%2C%20bright%20natural%20light%2C%20warm%20and%20inviting%20atmosphere%2C%20minimal%20background&width=600&height=400&seq=dukk-product-03&orientation=landscape",
  },
  {
    id: 4,
    title: "자영업자대출",
    subtitle: "매출만 확인되면 OK! 자영업자 든든 지원",
    maxAmount: "최대 5억원",
    tags: ["#자영업자", "#매출기준", "#빠른송금"],
    slug: "self-employed",
    image: "https://readdy.ai/api/search-image?query=Freelancer%20working%20on%20laptop%20in%20creative%20workspace%2C%20cafe%20interior%20with%20natural%20light%2C%20self%20employed%20professional%2C%20clean%20modern%20atmosphere%2C%20soft%20blue%20tinted%20background&width=600&height=400&seq=dukk-product-04&orientation=landscape",
  },
  {
    id: 5,
    title: "일수대출",
    subtitle: "긴급 자금이 필요할 때 당일 지원",
    maxAmount: "최대 1억원",
    tags: ["#일수", "#긴급자금", "#당일입금"],
    slug: "daily",
    image: "https://readdy.ai/api/search-image?query=Emergency%20financial%20support%20concept%2C%20clock%20and%20money%20symbol%2C%20fast%20transaction%2C%20blue%20and%20white%20modern%20design%2C%20clean%20minimal%20aesthetic%2C%20bright%20professional%20lighting&width=600&height=400&seq=dukk-product-05&orientation=landscape",
  },
];

export const comparisonData = [
  { name: "A은행", limit: "최대 3,000만원", feature: "10%금리,\n복잡한 서류", isHighlight: false },
  { name: "B대부업", limit: "최대 1억원", feature: "20%~금리", isHighlight: false },
  { name: "두꺼비대출", limit: "최대\n10억원", feature: "사업자 맞춤\n심사, 금리 3%~", isHighlight: true },
];

export const featureCards = [
  {
    id: 1,
    icon: "ri-file-list-3-line",
    title: "간편한 서류접수",
    description: "복잡한 서류는 이제 그만! 사업자 인증만으로 핵심 서류만 간편하게 접수하세요.",
  },
  {
    id: 2,
    icon: "ri-bar-chart-grouped-line",
    title: "높은 승인율",
    description: "신용점수가 조금 낮아도! 사업성을 우선으로 평가하여 승인율을 높였습니다.",
  },
  {
    id: 3,
    icon: "ri-smartphone-line",
    title: "무방문 모바일접수",
    description: "바쁘신 대표님을 위해! 지점 방문 없이 스마트폰 하나로 어디서든 신청 가능합니다.",
  },
  {
    id: 4,
    icon: "ri-rocket-line",
    title: "빠른 당일승인!",
    description: "오전 신청 시 오후 바로 송금해 드립니다. 기업의 막힘없는 자금 융통을 지원합니다.",
  },
];

export const approvalList = [
  { date: "26-07-14", name: "이**", product: "개인사업자", status: "승인완료" },
  { date: "26-07-14", name: "김**", product: "개인사업자", status: "승인완료" },
  { date: "26-07-14", name: "홍**", product: "법인사업자", status: "승인완료" },
  { date: "26-07-14", name: "권**", product: "기업단기", status: "승인완료" },
  { date: "26-07-14", name: "박**", product: "법인사업자", status: "승인완료" },
  { date: "26-07-14", name: "이**", product: "자영업자", status: "상담중" },
  { date: "26-07-14", name: "서**", product: "자영업자", status: "상담중" },
  { date: "26-07-14", name: "이**", product: "자영업자", status: "상담중" },
  { date: "26-07-13", name: "최**", product: "개인사업자", status: "승인완료" },
  { date: "26-07-13", name: "정**", product: "법인사업자", status: "승인완료" },
];

export const faqList = [
  {
    id: 1,
    question: "서류 준비할 시간이 없는데, 많이 복잡한가요?",
    answer: "아닙니다! '간편한 서류접수'를 원칙으로 합니다. 불필요한 서류 제출 없이 최소한의 필수 서류만 모바일로 간편하게 제출하시면 됩니다.",
  },
  {
    id: 2,
    question: "현재 신용점수가 낮은 편인데 대출이 가능할까요?",
    answer: "네, 가능합니다. 단순 신용점수보다 대표님의 매출과 사업성을 종합적으로 판단하므로 타사 대비 높은 승인율을 자랑합니다.",
  },
  {
    id: 3,
    question: "지점에 직접 방문해야 하나요? 너무 바빠서요.",
    answer: "방문하실 필요 없습니다! 바쁘신 대표님들의 시간을 절약해 드리기 위해 100% 무방문 모바일 접수로 진행됩니다.",
  },
  {
    id: 4,
    question: "급하게 자금이 필요한데 언제쯤 입금되나요?",
    answer: "기업의 자금 흐름은 속도가 생명입니다. 심사부터 송금까지 지연 없이 진행되는 빠른 당일승인 시스템을 갖추고 있습니다.",
  },
];

export const productPageData: Record<string, {
  title: string;
  subtitle: string;
  heroImage: string;
  maxAmount: string;
  description: string;
  conditions: string[];
  features: { icon: string; title: string; desc: string }[];
  faqs: { question: string; answer: string }[];
  requiredDocs: string[];
}> = {
  personal: {
    title: "개인사업자대출",
    subtitle: "개인사업자 사장님을 위한 넉넉한 맞춤대출",
    heroImage: "https://readdy.ai/api/search-image?query=Small%20business%20owner%20at%20modern%20workshop%2C%20retail%20store%20interior%2C%20entrepreneur%20with%20laptop%2C%20bright%20natural%20lighting%2C%20clean%20professional%20aesthetic%2C%20blue%20and%20white%20color%20scheme&width=1600&height=900&seq=dukk-personal-hero&orientation=landscape",
    maxAmount: "최대 10억원",
    description: "개인사업자 사장님들의 사업 운영을 위한 최적의 대출 솔루션입니다. 사업자등록증만으로 신청 가능하며, 매출 규모에 맞춰 유연한 한도를 설정해 드립니다.",
    conditions: [
      "사업자등록증을 보유한 개인사업자",
      "사업 운영 기간 3개월 이상",
      "연매출 1,000만원 이상",
    ],
    features: [
      { icon: "ri-calculator-line", title: "매출 기반 심사", desc: "신용점수와 무관하게 사업 매출을 기준으로 한도를 산정합니다." },
      { icon: "ri-time-line", title: "당일 승인", desc: "오전 접수 시 오후 송금까지 최대 3시간 내 처리됩니다." },
      { icon: "ri-percent-line", title: "낮은 금리", desc: "우량 사업자에게는 연 3%대부터 적용되는 특별 금리가 제공됩니다." },
    ],
    faqs: [
      { question: "사업자등록증만 있으면 대출이 가능한가요?", answer: "네, 사업자등록증과 매출 증빙 자료(카드매출, 현금영수증 등)만으로 신청 가능합니다." },
      { question: "신용점수가 낮은데도 승인이 되나요?", answer: "네, 매출과 사업성을 우선 평가하므로 신용점수가 낮더라도 충분히 승인 가능합니다." },
      { question: "대출 한도는 어떻게 결정되나요?", answer: "월평균 매출액의 3~10배 수준으로 한도가 산정되며, 최대 10억원까지 가능합니다." },
    ],
    requiredDocs: ["사업자등록증 사본", "매출 증빙 자료(3개월)", "신분증 사본", "통장 사본"],
  },
  corporate: {
    title: "법인사업자대출",
    subtitle: "법인 대표님들을 위한 든든한 사업자대출",
    heroImage: "https://readdy.ai/api/search-image?query=Modern%20corporate%20headquarters%20building%20exterior%2C%20executive%20office%20interior%2C%20professional%20business%20environment%2C%20blue%20tinted%20glass%2C%20bright%20daylight%2C%20clean%20minimal%20architectural%20photography&width=1600&height=900&seq=dukk-corporate-hero&orientation=landscape",
    maxAmount: "최대 10억원",
    description: "법인 대표님들의 경영 자금 확보를 위한 프리미엄 대출 상품입니다. 법인 매출과 재무 상태를 종합적으로 분석하여 최적의 조건을 제안해 드립니다.",
    conditions: [
      "법인사업자등록증을 보유한 법인",
      "법인 설립 후 6개월 이상 경과",
      "연매출 3,000만원 이상",
    ],
    features: [
      { icon: "ri-building-line", title: "법인 맞춤 심사", desc: "법인의 재무제표와 매출 추이를 면밀히 분석하여 최적의 조건을 제안합니다." },
      { icon: "ri-shield-check-line", title: "신용보증 연계", desc: "신용보증재단과의 연계로 보증서가 없는 법인도 신청 가능합니다." },
      { icon: "ri-exchange-dollar-line", title: "유연한 상환", desc: "원리금 균등, 거치 후 균등, 자유상환 등 다양한 상환 방식을 선택할 수 있습니다." },
    ],
    faqs: [
      { question: "법인 설립 후 얼마나 되어야 신청 가능한가요?", answer: "법인 설립 후 6개월 이상 경과한 법인이라면 신청 가능합니다." },
      { question: "대표자 개인 신용에 영향이 있나요?", answer: "법인 대출이므로 대표자 개인 신용에는 영향이 없습니다. 단, 연체 시에는 개인 신용에 반영될 수 있습니다." },
      { question: "재무제표가 미흡해도 가능한가요?", answer: "간편 매출 증빙(카드매출, 현금영수증)으로 대체 심사가 가능합니다." },
    ],
    requiredDocs: ["법인등기부등본", "사업자등록증", "재무제표 또는 매출 증빙", "대표자 신분증"],
  },
  "self-employed": {
    title: "자영업자대출",
    subtitle: "매출만 확인되면 OK! 자영업자 든든 지원",
    heroImage: "https://readdy.ai/api/search-image?query=Freelancer%20working%20in%20modern%20coworking%20space%2C%20creative%20professional%20with%20laptop%2C%20cafe%20workspace%2C%20bright%20natural%20light%2C%20blue%20and%20white%20modern%20interior%2C%20clean%20minimal%20aesthetic&width=1600&height=900&seq=dukk-self-hero&orientation=landscape",
    maxAmount: "최대 5억원",
    description: "자영업자분들의 꾸준한 매출 활동을 인정하여 신속하게 승인해 드립니다. 사업자등록증이 없어도 소득 증빙만으로 신청 가능합니다.",
    conditions: [
      "자영업 활동 6개월 이상",
      "소득 증빙 가능 (카드매출, 현금영수증 등)",
      "연 소득 1,500만원 이상",
    ],
    features: [
      { icon: "ri-user-smile-line", title: "사업자등록증 없이 가능", desc: "사업자등록증이 없어도 소득 증빙 자료로 충분히 심사가 가능합니다." },
      { icon: "ri-wallet-3-line", title: "최대 5억원 한도", desc: "자영업자의 소득 규모에 맞춰 최대 5억원까지 신속하게 승인해 드립니다." },
      { icon: "ri-flashlight-line", title: "긴급 자금 특화", desc: "월세, 인건비, 재고 확보 등 자영업자의 긴급 자금 수요에 최적화된 상품입니다." },
    ],
    faqs: [
      { question: "사업자등록증이 없어도 대출이 가능한가요?", answer: "네, 소득 증빙 자료(카드매출, 현금영수증 등)가 있다면 사업자등록증 없이도 신청 가능합니다." },
      { question: "자영업자 한도는 어떻게 결정되나요?", answer: "월평균 소득의 3~5배 수준으로 산정되며, 소득 규모와 거래 내역에 따라 달라집니다." },
      { question: "재고 확보 자금으로도 사용 가능한가요?", answer: "네, 대출 자금 용도는 자유롭게 사용 가능합니다. 월세, 재고, 인건비 모두 가능합니다." },
    ],
    requiredDocs: ["소득 증빙 자료(6개월)", "신분증 사본", "통장 사본"],
  },
  enterprise: {
    title: "기업단기자금",
    subtitle: "기업들의 자금 융통을 위한 간편 대출",
    heroImage: "https://readdy.ai/api/search-image?query=Modern%20industrial%20factory%20and%20warehouse%2C%20logistics%20center%20exterior%2C%20manufacturing%20facility%2C%20blue%20sky%20with%20white%20clouds%2C%20professional%20business%20photography%2C%20clean%20bright%20daylight&width=1600&height=900&seq=dukk-enterprise-hero&orientation=landscape",
    maxAmount: "최대 10억원",
    description: "중소기업의 단기 자금 융통을 위한 최적의 솔루션입니다. 급여, 재료비, 운영비 등 단기 자금 난에 신속하게 대응합니다.",
    conditions: [
      "중소기업 또는 소상공인",
      "사업 운영 기간 1년 이상",
      "연매출 5,000만원 이상",
    ],
    features: [
      { icon: "ri-timer-flash-line", title: "단기 특화", desc: "1~12개월 단기 상환 조건으로 급한 자금난에 빠르게 대응합니다." },
      { icon: "ri-stack-line", title: "최대 10억원", desc: "기업 규모와 매출에 맞춰 최대 10억원까지 유연하게 대출해 드립니다." },
      { icon: "ri-hand-heart-line", title: "경영 컨설팅", desc: "대출 외에도 기업의 자금 흐름 개선을 위한 전문 컨설팅을 함께 제공합니다." },
    ],
    faqs: [
      { question: "단기 대출은 상환 기간이 어떻게 되나요?", answer: "상환 기간은 1개월부터 12개월까지 선택 가능하며, 기업의 현금 흐름에 맞춰 조정됩니다." },
      { question: "기업 규모에 따라 한도가 달라지나요?", answer: "네, 연매출 규모와 사업 업종에 따라 한도가 달라지며, 최대 10억원까지 가능합니다." },
      { question: "단기 대출인데 중도 상환이 가능한가요?", answer: "네, 중도 상환이 가능하며 조기 상환 수수료도 없습니다." },
    ],
    requiredDocs: ["사업자등록증", "재무제표(최근 2기)", "매출 증빙 자료", "대표자 신분증"],
  },
  daily: {
    title: "일수대출",
    subtitle: "긴급 자금이 필요할 때 당일 지원",
    heroImage: "https://readdy.ai/api/search-image?query=Fast%20emergency%20money%20transfer%20concept%2C%20modern%20smartphone%20with%20money%20icon%2C%20speed%20and%20urgency%20symbol%2C%20blue%20and%20white%20tech%20background%2C%20clean%20minimal%20design%2C%20professional%20lighting&width=1600&height=900&seq=dukk-daily-hero&orientation=landscape",
    maxAmount: "최대 1억원",
    description: "갑작스러운 자금난에 당일 신청, 당일 송금으로 신속하게 대응합니다. 간단한 서류와 빠른 심사로 긴급 상황을 해결해 드립니다.",
    conditions: [
      "만 20세 이상 성인",
      "정규 소득 또는 사업 소득 보유",
      "신분증 및 소득 증빙 가능",
    ],
    features: [
      { icon: "ri-lightbulb-flash-line", title: "최대 1시간 심사", desc: "접수부터 심사까지 최대 1시간 내에 처리됩니다." },
      { icon: "ri-wallet-3-line", title: "최대 1억원", desc: "긴급 자금 수요에 맞춰 최대 1억원까지 당일 지원해 드립니다." },
      { icon: "ri-file-list-3-line", title: "서류 간소화", desc: "신분증과 소득 증빙만으로 최소한의 서류로 신청 가능합니다." },
    ],
    faqs: [
      { question: "일수대출은 몇 일 단위로 가능한가요?", answer: "7일, 14일, 30일, 60일, 90일 단위로 선택 가능하며, 연장도 가능합니다." },
      { question: "당일 입금이 정말 가능한가요?", answer: "네, 오전 11시까지 접수 완료 시 오후 3시 이전에 송금 처리됩니다." },
      { question: "일수대출 금리는 어떻게 되나요?", answer: "일수 단위로 계산되며, 연환산 20% 이내에서 합리적인 금리가 적용됩니다." },
    ],
    requiredDocs: ["신분증 사본", "소득 증빙 자료", "통장 사본"],
  },
};